import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SVG from 'components/widgets/icons/svg';

export default function EmptyPagePlaceholder({ src, children, className, ...passed }) {
  return (
    <div {...passed} className={classNames(className, { clickable: passed.onClick }, 'page-empty-text')}>
      { src && <SVG src={src} /> }
      <span>{children}</span>
    </div>
  );
}

EmptyPagePlaceholder.propTypes = {
  src: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
